var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.75 5.25H6.75V0.25C6.75 0.125 6.625 0 6.5 0H5.5C5.34375 0 5.25 0.125 5.25 0.25V5.25H0.25C0.09375 5.25 0 5.375 0 5.5V6.5C0 6.65625 0.09375 6.75 0.25 6.75H5.25V11.75C5.25 11.9062 5.34375 12 5.5 12H6.5C6.625 12 6.75 11.9062 6.75 11.75V6.75H11.75C11.875 6.75 12 6.65625 12 6.5V5.5C12 5.375 11.875 5.25 11.75 5.25Z",
    fill: "#2A2A2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.769d0a74.svg";
export { ForwardRef as ReactComponent };